// extracted by mini-css-extract-plugin
export default {"expandInfo":"Cadastrar_expandInfo__BJW-y","estiloTabs":"Cadastrar_estiloTabs__U7dCr","btnFormularios":"Cadastrar_btnFormularios__DyfzT"};